/** ES `account_pairs` 필터 한 칸 — 소문자 플랫폼과 `@` 없는 계정 */
export type AccountPair = { platform: string; account: string };

/** 캠페인 문서에 담기는 계정 한 건. 필드 이름이 두 벌씩이라 넓게 받는다 */
export type CampaignAccountLike = {
  platform?: unknown;
  source?: unknown;
  account?: unknown;
  username?: unknown;
};

/**
 * 계정 줄 열쇠(소문자 `platform*account`) — 계정별 표가 글을 계정에 붙이는 기준이다.
 * 채널이 없으면 `*account`. 계정 이름은 앞뒤 공백만 떼고 소문자로 맞춘다.
 */
export function campaignAccountKey(platform: unknown, account: unknown): string {
  return `${String(platform || '').trim().toLowerCase()}*${String(account || '').trim().toLowerCase()}`;
}

/** 계정 목록 → account_pairs 필터 값 ({platform, account}) */
export function toAccountPairs(accounts: unknown): AccountPair[] {
  const seen = new Set<string>();
  const out: AccountPair[] = [];
  (Array.isArray(accounts) ? (accounts as CampaignAccountLike[]) : []).forEach((a) => {
    const platform = String(a?.platform ?? a?.source ?? '').trim().toLowerCase();
    const account = String(a?.account ?? a?.username ?? '').trim().replace(/^@/, '');
    if (!platform || !account) return;
    const key = `${platform}*${account.toLowerCase()}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push({ platform, account });
  });
  return out;
}

/** 캠페인 문서에서 계정 배열 추출.
 * 시딩: keywordFilter.accounts 우선 (캠페인 화면과 동일)
 * 키워드 모니터링: top-level accounts 우선 (keyword-view와 동일) — preferTopLevel */
export function getCampaignAccounts(
  campaign: { keywordFilter?: { accounts?: unknown } | null; accounts?: unknown } | null | undefined,
  { preferTopLevel = false }: { preferTopLevel?: boolean } = {}
): CampaignAccountLike[] {
  const fromFilter = Array.isArray(campaign?.keywordFilter?.accounts)
    ? (campaign.keywordFilter.accounts as CampaignAccountLike[])
    : null;
  const fromTop = Array.isArray(campaign?.accounts)
    ? (campaign.accounts as CampaignAccountLike[])
    : null;
  const pickNonEmpty = (a: CampaignAccountLike[] | null, b: CampaignAccountLike[] | null) => {
    if (Array.isArray(a) && a.length > 0) return a;
    if (Array.isArray(b) && b.length > 0) return b;
    return a ?? b ?? [];
  };
  return preferTopLevel ? pickNonEmpty(fromTop, fromFilter) : pickNonEmpty(fromFilter, fromTop);
}
